import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useOrderTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
